import styles from "./EstimateStep1.module.scss";
import classNames from "classnames/bind";
import { Calendar1Icon } from "lucide-react";
import { forwardRef, InputHTMLAttributes, useRef, useState, useEffect } from "react";
import { TextField } from "@mui/material";
import BaseUploadFileV2 from "~/components/common/base-upload-file-v2/BaseUploadFileV2";
import FormDatePicker from "~/components/common/form/base-date-pickerV2/FormDatePicker";
import FormInput from "~/components/common/form/formInput/FormInput";
import { EstimateModeViewEnum } from "~/pages/admin/jobs/add-job/constants/add-estimate.constants";
import TitleEditor from "~/components/common/form/titleEdit/TitleEditor";
import { PlusIcon } from "~/assets/icons";
import { notify } from "~/utils/helper";

const cx = classNames.bind(styles);

type TextFieldInputProps = InputHTMLAttributes<HTMLInputElement>;

interface EstimateStep1Props {
    onChange: (formData: any) => void,
    data: any,
    mode: string,
    errorForm: any,
    onPreview: () => void,
    primaryContact?: any,
}

const EstimateStep1 = ({ onChange, data, mode, errorForm, onPreview, primaryContact }: EstimateStep1Props) => {

    const [formData, setFormData] = useState<{
        name: string,
        date: Date,
        file: File,
        company: string,
        firstName: string,
        lastName: string,
        address: string,
        city: string,
        province: string,
        code: string,
        fileUrl: string,
        titleStep1: string,
    }>(data);

    useEffect(() => {
        setFormData(data);
    }, [data]);

    useEffect(() => {
        if (primaryContact && mode === EstimateModeViewEnum.CREATE) {
            const shouldFill = !formData?.firstName && !formData?.lastName && !formData?.address;

            if (shouldFill) {
                const nameParts = primaryContact.name?.trim().split(/\s+/) || [];
                const firstName = nameParts[0] || '';
                const lastName = nameParts.slice(1).join(' ') || '';

                const updatedData = {
                    ...formData,
                    name: primaryContact.name || '',
                    firstName: firstName,
                    lastName: lastName,
                    address: primaryContact.address || '',
                    city: primaryContact.city || '',
                    province: primaryContact.stateProvince || '',
                    code: primaryContact.zipCodePostalCode || '',
                };

                setFormData(updatedData);
                onChange(updatedData);
            }
        }
    }, [primaryContact, mode]);

    const [error, setError] = useState({
        name: '',
        date: '',
        file: '',
        company: "",
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        province: '',
        code: '',
        titleStep1: "Title & Details",
    });

    const [isOpen, setIsOpen] = useState(false);
    const [dateText, setDateText] = useState<string>('');
    const [photos, setPhotos] = useState<any[]>([])
    const [photoSelectDetail, setPhotoSelectDetail] = useState<any | null>(null);
    const [primaryImageError, setPrimaryImageError] = useState<string>("");
    const ref = useRef<any>(null);

    const onSavePhoto = (isCreate: boolean, data: any) => {
        // if(isCreate){
        // handleUpload(data);
        // }else{
        // handleEditPhoto(data)
        // }
    }

    const TextFieldInput = forwardRef<HTMLInputElement, TextFieldInputProps>(({ onClick }, ref) => (
        <TextField
            ref={ref}
            inputProps={{ readOnly: true }}
            InputProps={{
                endAdornment: <Calendar1Icon className='w-[13px]' />,
                inputProps: {
                    classes: "input-field"
                }
            }}
            onClick={onClick}
            value={dateText}
            placeholder={"Select date"}
            error={error.date != ""}
            helperText={error.date}

        />
    ));

    const handleUpdateData = (update: any) => {
        let data: any = { ...formData, ...update }
        // data[key] = value;
        onChange(data);
        setFormData(data)
    }

    const handleChangeImage = () => {
        if (ref) {
            let upLoadFile: any = ref.current;
            upLoadFile.opendUploadFile();
        }
    }


    return (<>
        <div className={cx('estimate-step-container')}>
            <div className={cx('header', 'flex items-center justify-between')}>
                <TitleEditor value={formData.titleStep1}
                    name={""}
                    isViewMode={mode == EstimateModeViewEnum.VIEW}
                    placeholder={""}
                    inputkey={""}
                    onChange={(value) => {
                        handleUpdateData({
                            ...formData,
                            titleStep1: value
                        })
                    }}
                    styleView={{
                        fontSize: "20px",
                        fontWeight: 700,
                    }}
                />

                <div>
                    <button onClick={onPreview} className={cx('btn-preview')}>
                        View Page
                    </button>
                </div>
            </div>
            <div className={cx('content')}>
                <div className={cx('estimate-row')}>
                    <div className="w-[60%]">
                        <div className={cx("base-input")}>
                            <FormInput
                                name={"name"}
                                isViewMode={mode == EstimateModeViewEnum.VIEW}
                                text={"Estimate Name"}
                                placeholder={"Enter estimate name"}
                                inputkey={"name"}
                                value={formData.name}
                                error={errorForm.name}
                                onChange={(e) => {
                                    handleUpdateData({
                                        ...formData,
                                        name: e.target.value
                                    })
                                }}
                            />
                            {error.name && (
                                <div className={cx("error-message")}>{error.name}</div>
                            )}
                        </div>
                    </div>
                    <div className="w-[40%]">
                        <FormDatePicker
                            text={"Date"}
                            selectRange={false}
                            value={formData.date}
                            error={errorForm.name}
                            onChange={(e) => {
                                handleUpdateData({
                                    ...formData,
                                    date: e
                                })
                            }} />
                    </div>
                </div>

                <div className={cx('estimate-row')}>
                    <div className="w-full">
                        <div className={cx("base-input")}>
                            <h3 className={cx({
                                "input-label": true,
                                "while": true
                            })}>Primary Image</h3>
                        </div>

                        <div className="mt-[16px]" style={{
                            marginTop: "16px"
                        }}>
                            <BaseUploadFileV2
                                ref={ref}
                                url={formData.fileUrl}
                                isViewMode={mode == EstimateModeViewEnum.VIEW}
                                errorMessage={primaryImageError || errorForm.primaryImage}
                                onChange={(data: any) => {
                                    const file = data.file as File | undefined;

                                    if (file && file.size > 10 * 1024 * 1024) {
                                        setPrimaryImageError("File size must be less than 10MB");
                                        notify("error", "File size must be less than 10MB");
                                        // Không lưu file quá lớn vào formData
                                        handleUpdateData({
                                            ...formData,
                                            file: undefined,
                                            fileUrl: "",
                                        });
                                        return;
                                    }

                                    setPrimaryImageError("");

                                    handleUpdateData({
                                        ...formData,
                                        file: data.file,
                                        fileUrl: data.fileUrl,
                                    })
                                }}
                            />
                        </div>

                        {
                            mode != EstimateModeViewEnum.VIEW &&
                            <button className={cx('add-image', 'mt-[32px]')}
                                onClick={handleChangeImage}
                            >
                                <PlusIcon className="w-[14px] h-[14px] [&>path]:fill-[#2D80FC]" color="#2D80FC" />

                                {formData.fileUrl ? "Change Certificate Logo" : "Add Certificate Logo"}
                            </button>
                        }

                    </div>

                </div>

                <div className={cx('sub-title')}>
                    <h2>Additional Information</h2>
                </div>

                <div className={cx('estimate-row')}>
                    <FormInput
                        name={"company"}
                        text={"Company name (Optional)"}
                        placeholder={"Company name"}
                        inputkey={"company"}
                        value={formData.company}
                        error={errorForm.companyName}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        onChange={(e) => {
                            handleUpdateData({
                                ...formData,
                                company: e.target.value
                            })
                        }}
                    />

                    <FormInput
                        name={"firstName"}
                        text={"First Name"}
                        placeholder={"First name"}
                        inputkey={"firstName"}
                        value={formData.firstName}
                        error={errorForm.firstName}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        onChange={(e) => {
                            handleUpdateData({
                                ...formData,
                                firstName: e.target.value
                            })
                        }}
                    />
                    <FormInput
                        name={"lastName"}
                        text={"Last Name"}
                        placeholder={"Last name"}
                        inputkey={"lastName"}
                        value={formData.lastName}
                        error={errorForm.lastName}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        onChange={(e) => {
                            handleUpdateData({
                                ...formData,
                                lastName: e.target.value
                            })
                        }}
                    />
                </div>

                <div className={cx('estimate-row')}>
                    <div className="w-full">
                        <FormInput
                            name={"address"}
                            text={"Address"}
                            placeholder={"Address"}
                            inputkey={"address"}
                            value={formData.address}
                            error={errorForm.address}
                            isViewMode={mode == EstimateModeViewEnum.VIEW}
                            onChange={(e) => {
                                handleUpdateData({
                                    ...formData,
                                    address: e.target.value
                                })
                            }}
                        />
                    </div>
                    <FormInput
                        name={"city"}
                        text={"City"}
                        placeholder={"City"}
                        inputkey={"city"}
                        value={formData.city}
                        error={errorForm.city}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        onChange={(e) => {
                            handleUpdateData({
                                ...formData,
                                city: e.target.value
                            })
                        }}
                    />
                    <FormInput
                        name={"province"}
                        text={"State/ Province"}
                        placeholder={"State/ Province"}
                        inputkey={"province"}
                        value={formData.province}
                        error={errorForm.stateProvince}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        onChange={(e) => {
                            handleUpdateData({
                                ...formData,
                                province: e.target.value
                            })
                        }}
                    />
                </div>

                <div className={cx('estimate-row')}>
                    <div className="263px">
                        <FormInput
                            name={"code"}
                            text={"Zip code / Postal code"}
                            placeholder={"Zip code / Postal code"}
                            inputkey={"company"}
                            isViewMode={mode == EstimateModeViewEnum.VIEW}
                            error={errorForm.zipCodePostalCode}
                            value={formData.code}
                            onChange={(e) => {
                                handleUpdateData({
                                    ...formData,
                                    code: e.target.value
                                })
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default EstimateStep1;